// Generated by scripts/generate-app-version.mjs. Do not edit manually.
export const APP_VERSION = {
  "version": "0.5.5",
  "commit": "cbd448b",
  "dirty": true,
  "builtAt": "2026-10-02T17:02:57.550Z",
  "buildId": "cbd448b-dirty-20261002T170257550Z"
} as const;
